import axios, { AxiosRequestConfig } from 'axios';
import { HttpParameters } from '@/models';

const httpRequest = (url: string, params: HttpParameters): Promise<object> => {
  return new Promise((resolve: (data: object) => void, reject: (error: Error) => void) => {
    let method: AxiosRequestConfig['method'];
    switch (params.method) {
      case 'GET':
        method = 'GET';
        break;
      case 'POST':
        method = 'POST';
        break;
      case 'PUT':
        method = 'PUT';
        break;
      default:
        method = 'GET';
    }

    axios({
      method,
      url,
      data: params.body,
      headers: params.header
    }).then((response: object) => {
      resolve(response);
    }).catch((e) => {
      reject(e);
    });
  });
};

const setHeader = async (header?: object): Promise<object> => {
  if (!header) {
    header = {};
  }
  let apiKey: { [key: string]: string } = {};
  if (process.env.VUE_APP_MOBILE_API_KEY) {
    apiKey = {
      'X-Api-Key': process.env.VUE_APP_MOBILE_API_KEY
    };
  } else {
    console.error('VUE_APP_MOBILE_API_KEY env_var is not been set! :(');
  }
  return { ...header, ...apiKey };
};

const httpRequestUrlEncoding = (method: string): ((url: string, header?: object) => Promise<object>) => {
  return async (url: string, header?: object): Promise<object> => {
    header = await setHeader(header);
    const httpResponse: any = await httpRequest(url, {
      encoding: 'json',
      method,
      header
    });
    return httpResponse.data;
  };
};

const httpRequestJsonEncoding = (method: string): ((url: string, body?: object, header?: object) => Promise<object>) => {
  return async (url: string, body?: object, header?: object): Promise<object> => {
    header = await setHeader(header);
    const httpResponse: any = await httpRequest(url, {
      encoding: 'json',
      body: JSON.stringify(body),
      method,
      header
    });

    return typeof httpResponse.body === 'object' ? JSON.parse(httpResponse.body) : httpResponse.body;
  };
};

export const getRequest = httpRequestUrlEncoding('GET');
export const postRequest = httpRequestJsonEncoding('POST');
export const patchRequest = httpRequestJsonEncoding('PATCH');
export const putRequest = httpRequestJsonEncoding('PUT');
